module.exports = __webpack_public_path__ + "static/media/2-en.c41a062d.svg";